import { useNewChallenge } from "contexts/Challenge/NewChallenge";
import React from "react";

const FormFeedback = () => {
  const { formError } = useNewChallenge();

  if (formError) return <div className="form-feedback">{formError}</div>;

  return null;
};

export default FormFeedback;
